import React, { useEffect, useState } from "react";
import { useParams, useLocation } from 'react-router-dom';
import { toggleOrderStatusApi } from "../../../Apis/OrderApi";

const OrderApproval = () => {
  const [approveOrder, setApproveOrder] = useState(false);
  const [rejectOrder, setRejectOrder] = useState(false);
  const [toggleStatus, setToggleStatus] = useState("");
  const location = useLocation();
  const { orderID }  = useParams();
  const order = location.state?.order;

  const toggleApproveOrder = () => {
    setApproveOrder(!approveOrder);
  };

  const toggleRejectOrder = () => {
    setRejectOrder(!rejectOrder);
  };

  // api for the toggle order status
  const sellerToggleOrderStatus = async (orderID, orderStatus) =>{
    try{
      const response = await toggleOrderStatusApi(orderID, orderStatus);
      setToggleStatus(response);
    }catch(error){
      console.log("Error to change the order status");
    }
  }

  useEffect(() => {
    if (approveOrder) {
      sellerToggleOrderStatus(order.orderID,"Approved");
    }
    if (rejectOrder) {
      sellerToggleOrderStatus(order.orderID,"Rejected");
    }
  }, [approveOrder, rejectOrder]);

  const formatOrderDate = (dateString) => {
    if (!dateString) {
      return "Invalid Date";
    }
  
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return "Invalid Date";
    }
  
    const options = { day: '2-digit', month: 'long', year: 'numeric' };
    return new Intl.DateTimeFormat('en-IN', options).format(date);
  };
  

  return (
    <div className="w-full h-[1200px] flex items-center justify-center">
      <div className="w-[1014px] h-[935px] bg-[#FFF9F2] rounded-r-[10px] flex flex-col px-[30px] pt-[50px] items-center gap-y-[20px]">
        <div className="w-[954px] h-[121px] rounded-[10px] bg-white py-[25px] pl-[26px] pr-[35px] flex flex-row items-center justify-between gap-x-[24px] drop-shadow-[0_0px_2px_rgba(0,0,0,0.10)]">
          <img
            src={order?.images[0]}
            alt=""
            className="w-[57px] h-[69px]"
          />
          <div className="flex items-center justify-between flex-row w-full">
            <div className="flex flex-col items-start justify-between h-[67px]">
              <h4 className="w-[301px] h-[24px] text-start text-black font-semibold text-[16px]">
                {order?.productTitle}
              </h4>
              <div className="flex flex-row w-[315px] gap-x-[16px] items-center justify-start">
                <p className="w-[143px] h-[35px] rounded-[5px] bg-[#F2F2F2] flex items-center justify-center text-black font-medium text-[14px]">
                  Quantity :{" "}
                  <span className="text-black font-semibold text-[14px]">
                  {order?.quantity} Unit
                  </span>
                </p>
                <p className="w-[140px] h-[21px] font-medium text-[14px] text-start text-black">
                  Order ID : {order?.orderID}
                </p>
              </div>
            </div>
            <div className="flex flex-col items-end justify-between h-[57px]">
              <p className="w-[105px] h-[24px] font-medium text-black text-end text-[16px]">
                Order Value :
              </p>
              <p className="w-[70px] h-[24px] font-semibold text-[16px] text-end text-black">
                ₹ {order?.totalAmount}
              </p>
            </div>
          </div>
        </div>

        <div className="w-[954px] h-[435px] rounded-[10px] bg-white pt-[19px] pl-[24px] pb-[23px] flex flex-row drop-shadow-[0_0px_2px_rgba(0,0,0,0.10)]">
          <div className="flex flex-col">
            <h3 className="w-[107px] h-[24px] text-black text-start font-semibold text-[16px]">
              Order Details
            </h3>
            <hr className="w-[163px] h-[2px] bg-[#FF6300] mt-[9px]" />
            <div className="flex flex-wrap w-[435px] h-auto mt-[22px] justify-between">
              <div className="w-[262px] h-[75px] flex flex-col items-start justify-between">
                <h4 className="w-[94px] h-[21px] font-semibold text-[14px] text-start text-black">
                  Buyer Details
                </h4>
                <p className="w-[141px] h-[54px] text-start text-black font-medium text-[14px] leading-[30px]">
                  {order?.name}. Phone :{order?.buyerPhoneNumber}
                </p>
              </div>

              <div className="w-[125px] h-[51px] flex flex-col items-start gap-y-[4px]">
                <h4 className="w-[85px] h-[21px] font-semibold text-[14px] text-start text-black">
                  Order Date :
                </h4>
                <p className="w-[125px] h-[23px] text-start text-black font-medium text-[14px]">
                  {formatOrderDate(order?.orderDate)}
                </p>
              </div>

              <div className="w-[262px] h-[160px] flex flex-col items-start justify-between mt-[40px]">
                <h4 className="w-[127px] h-[21px] font-semibold text-[14px] text-start text-black">
                  Delivery Address :
                </h4>
                <p className="w-[262px] h-[135px] text-start text-black font-medium text-[14px] leading-[32px]">
                  {order?.billingAddress} City :{order?.city} State :
                  {order?.state} Phone :{order?.buyerPhoneNumber} Pincode : 400002
                </p>
              </div>
            </div>
          </div>

          <div className="w-[48px] h-full flex items-center justify-end">
            <hr className="w-[0.5px] h-full bg-[#D8D8D8]" />
          </div>

          {approveOrder ? (
            <div className="w-[445px] h-[393px] py-[33px] px-[48px] flex flex-col items-center justify-center">
              <h4 className="w-[145px] h-[24px] font-semibold text-[16px] text-black">
                Payment Pending
              </h4>
              <p className="w-[124px] h-[124px] bg-[#FEECD4] rounded-full flex items-center justify-center mt-[31px]">
                <svg
                  width="72"
                  height="72"
                  viewBox="0 0 72 72"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M51 24V15C51 14.2044 50.6839 13.4413 50.1213 12.8787C49.5587 12.3161 48.7956 12 48 12H18C16.4087 12 14.8826 12.6321 13.7574 13.7574C12.6321 14.8826 12 16.4087 12 18M12 18C12 19.5913 12.6321 21.1174 13.7574 22.2426C14.8826 23.3679 16.4087 24 18 24H54C54.7956 24 55.5587 24.3161 56.1213 24.8787C56.6839 25.4413 57 26.2044 57 27V36M12 18V54C12 55.5913 12.6321 57.1174 13.7574 58.2426C14.8826 59.3679 16.4087 60 18 60H54C54.7956 60 55.5587 59.6839 56.1213 59.1213C56.6839 58.5587 57 57.7956 57 57V48M60 36V48H48C46.4087 48 44.8826 47.3679 43.7574 46.2426C42.6321 45.1174 42 43.5913 42 42C42 40.4087 42.6321 38.8826 43.7574 37.7574C44.8826 36.6321 46.4087 36 48 36H60Z"
                    stroke="black"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </p>
              <p className="w-[320px] h-[21px] font-semibold text-[14px] text-black mt-[36px]">
                Payment process is initiated and in progress.
              </p>
              <p className="w-[297px] h-[48px] font-medium text-[14px] text-black mt-[6px] text-center leading-[25px]">
                You will be notified once buyer completes payment process.
              </p>
            </div>
          ) : (
            <div className="w-[445px] h-[393px] py-[33px] px-[48px] flex flex-col items-center justify-center">
              <h4 className="w-[125px] h-[24px] font-semibold text-[16px] text-black">
                Order Approval
              </h4>
              <p className="w-[124px] h-[124px] bg-[#FEECD4] rounded-full flex items-center justify-center mt-[31px]">
                <svg
                  width="71"
                  height="71"
                  viewBox="0 0 71 71"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_1253_14352)">
                    <path
                      d="M14.7891 14.7917C14.7891 13.2225 15.4124 11.7175 16.522 10.608C17.6316 9.49836 19.1365 8.875 20.7057 8.875H50.2891C51.8583 8.875 53.3632 9.49836 54.4728 10.608C55.5824 11.7175 56.2057 13.2225 56.2057 14.7917V56.2083C56.2057 57.7775 55.5824 59.2825 54.4728 60.392C53.3632 61.5016 51.8583 62.125 50.2891 62.125H20.7057C19.1365 62.125 17.6316 61.5016 16.522 60.392C15.4124 59.2825 14.7891 57.7775 14.7891 56.2083V14.7917Z"
                      stroke="black"
                      stroke-width="4"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M26.625 20.707H44.375"
                      stroke="black"
                      stroke-width="4"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M26.625 32.543H44.375"
                      stroke="black"
                      stroke-width="4"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M26.625 44.375H38.4583"
                      stroke="black"
                      stroke-width="4"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1253_14352">
                      <rect width="71" height="71" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </p>
              <p className="w-[249px] h-[21px] font-semibold text-[14px] text-black mt-[36px]">
                Do you want to approve the order ?
              </p>
              <p className="w-[349px] h-[21px] font-medium text-[14px] text-black mt-[6px]">
                Buyer will be notified once you approve the order.{" "}
              </p>
              <div className="w-[241px] flex flex-row items-center justify-between h-[36px] mt-[27px]">
                <button
                  className="w-[117px] h-[36px] text-white flex items-center justify-center font-medium text-[12px] bg-[#FF6300] rounded-[5px]"
                  onClick={toggleApproveOrder}
                >
                  Approve Order
                </button>
                <button className="w-[105px] h-[36px] text-black border rounded-[5px] flex items-center justify-center font-medium text-[12px]"
                  onClick={toggleRejectOrder}
                >
                  Reject Order
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrderApproval;
